<nav class="navbar navbar-light navbar-expand bg-white shadow mb-4 topbar static-top fixed-top">
    <div class="container-fluid">
      <div class="d-sm-flex d-md-flex d-xl-flex align-items-sm-center align-items-xl-center" id="logoBlock"><img src="assets/v2/img/EPC-logo.svg" style="height: 40px;"></div>
    </div>
  </nav>
